var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1764",
    transform: "translate(-300 -300)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1765",
    transform: "translate(306.154 302.154)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 71",
    cx: 1.846,
    cy: 1.846,
    r: 1.846,
    fill: "#3c2f87"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1567",
    d: "M487.692 530.769a3.077 3.077 0 0 0-3.077 3.077v1.231a1.231 1.231 0 0 0 1.231 1.231v2.462a1.846 1.846 0 0 0 3.692 0v-2.462a1.231 1.231 0 0 0 1.231-1.231v-1.231a3.077 3.077 0 0 0-3.077-3.077z",
    transform: "translate(-179.692 -224.615)",
    fill: "#3c2f87"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 72",
    cx: 1.846,
    cy: 1.846,
    r: 1.846,
    transform: "translate(311.077 300)",
    fill: "#3c2f87"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1568",
    d: "M680.775 453.077v1.231a1.234 1.234 0 0 1-1.231 1.231V458a1.846 1.846 0 1 1-3.692 0v-.172a1.827 1.827 0 0 0 .615-1.366v-1.231a3.673 3.673 0 0 0-1.7-3.1 3.078 3.078 0 0 1 6.006.948z",
    transform: "translate(-364.775 -146)",
    fill: "#3c2f87"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 73",
    cx: 1.846,
    cy: 1.846,
    r: 1.846,
    transform: "translate(301.231 300)",
    fill: "#3c2f87"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1569",
    d: "M304.308 456.462a1.828 1.828 0 0 0 .615 1.366V458a1.846 1.846 0 1 1-3.692 0v-2.462a1.234 1.234 0 0 1-1.231-1.23v-1.231a3.078 3.078 0 0 1 6.006-.948 3.673 3.673 0 0 0-1.7 3.1z",
    transform: "translate(0 -146)",
    fill: "#3c2f87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.491f9e72afb9e4a24951b09ddeee0e45.svg";
export { ForwardRef as ReactComponent };